export const USER_LOGIN_FIRST_STEP = "USER_LOGIN_FIRST_STEP";
export const USER_LOGGED_IN = "USER_LOGGED_IN";
/**Deprecated */
export const USER_INFO_RECEIVED = "USER_INFO_RECEIVED";
export const USER_UPDATE_SELECTED_PRODUCT = "USER_UPDATE_SELECTED_PRODUCT";
export const USER_CHANGE_SELECTED_PRODUCT = "USER_CHANGE_SELECTED_PRODUCT";
export const USER_SET_SELECTED_CARD_EC_METHOD = "USER_SET_SELECTED_CARD_EC_METHOD";
export const USER_SET_SMS_ACTIVATION = "USER_SET_SMS_ACTIVATION";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
